import * as React from 'react';
import * as Redux from 'redux';
import * as ReactRedux from 'react-redux';
import * as Tgcc from '../tgccGlobal';
import * as TgccRequest from '../tgccRequest';
import Radium, { StyleRoot } from 'radium';
import {connect} from 'react-redux';
import {CSSProperties} from 'react';
import {BulletLine} from '../Components/BulletLine';
import {DesignCategory} from './DesignCategory';
import {DesignLicense} from './DesignLicense';
import {DesignCard} from './DesignCard';
import {CloseX} from '../Components/CloseX';
import {ScreenDoor} from '../Components/ScreenDoor';

const DIVISION: string = 'Corporate';

const categoryContainerStyle : CSSProperties = {
    position: 'relative',
    width: '90%',
    maxHeight: '400px',
    minHeight: '140px',
    display: 'flex',
    flexDirection: 'column',
    padding: '10px 30px',
    textTransform: 'uppercase',
    boxShadow: Tgcc.Styles.boxShadow,
    backgroundColor: 'white',
    marginBottom: '15px',
    flexShrink: 0,
    '@media (max-width:800px) and (max-height:1280px)': {
        width:'95%'
    },
    '@media (max-width:768px) and (max-height:1366px)': {
        width:'94%'
    },
    '@media (max-width:768px) and (max-height:1024px)': {
        width:'94%'
    },
    '@media (max-width:414px)': {
        width:'380px',
        height:'200px'
    },
    '@media (max-width:375px)': {
        width:'305px',
        height:'170px'
    },
    '@media (max-width:320px)': {
        width:'275px',
    }
};
const searchStyle : CSSProperties = {
    display: 'flex',
    alignSelf: 'center',
    fontFamily: 'CenturyGothic',
    fontSize: '16px',
    letterSpacing: '6px',
    backgroundColor: Tgcc.Styles.inputBackground,
    textAlign: 'center',
    border: 'none',
    padding: '3px 0 3px 7px',
    textTransform: 'uppercase',
    width: '400px',
    '@media (max-width:1024px) and (max-height:1366px)': {
        margin:'auto'
    },
    '@media (max-width:768px) and (max-height:1024px)': {
        margin:'auto'
    },
    '@media (max-width:375px)': {
    },
    '@media (max-width:360px)': {
       lineHeight:'25px',
    },
    '@media (max-width:320px)': {
        width:'264px',
        fontSize:'8px',
        height:'22px'
    }
};
const smHeadStyle : CSSProperties = {
    display: 'flex',
    alignSelf: 'center',
    fontFamily: 'CenturyGothic',
    fontSize: '8px',
    letterSpacing: '5px',
    
};

const categoryListStyle : CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    maxHeight: '100px',
    paddingBottom: '5px',
    overflowX: 'hidden',
    overflowY: 'auto',
    marginTop: '15px',
    marginLeft: '35px',
    lineHeight: '15px',
    '@media (max-width:414px)': {
        maxHeight:'160px'
    },
    '@media (max-width:375px)': {
        maxHeight:'150px'
    },
    '@media (max-width:320px)': {
        maxHeight:'156px'
    }
};

const selectorStyle : CSSProperties = {
    position: 'relative',
    display: 'flex',
    zIndex: 9,
    margin: '50px auto',
    width: '80%',
    maxHeight: '80%',
    minHeight: '500px',
    boxShadow: Tgcc.Styles.boxShadow,
    backgroundColor: 'rgba(255,255,255,0.96)',
    flexDirection: 'column',
    justifyContent: 'space-around',
    alignItems: 'center',
    padding: '15px',
    '@media (max-width:1024px) and (max-height:1366px)': {
        minHeight:'750px'
    },
    '@media (max-width:800px) and (max-height:1280px)': {
        width:'95%'
    },
    '@media (max-width:768px)': {
        width:'94%',
        minHeight:'650px'
    },
    '@media (max-width:412px)': {
        position:'absolute',
        width:'90%',
        top:'-6%',
    },
    '@media (max-width:360px)': {
        top:'0%',
        minHeight:'475px',
        left:'3%',
        position:'absolute'
    },
    '@media (max-width:320px)': {
        width:'80%',
        top:'-5%',
        minHeight:'470px'
    }
};

const catalogStyle : CSSProperties = {
    display: 'flex',
    flexWrap: 'wrap',
    width: '90%',
    flexGrow: 2,
    overflowX: 'hidden',
    overflowY: 'auto',
};
const closeXStyle: CSSProperties = {
    '@media (max-width:414px)': {
        position:'relative',
        left:'22px',
        top:'-10px'
    },
    '@media (max-width:375px)': {
        left:'33px',
        top:'-8px'
    },
    '@media (max-width:360px)': {
        left:'28px',
        top:'-10px'
    },
    '@media (max-width:320px)': {
        left:'22px',
        top:'-7px'
    }
}
const searchIcon: CSSProperties = {
    width:'20px',
    height:'20px'
}
const searchFormStyle: CSSProperties = {
    textAlign:'center',
    marginBottom:'0px'
}
const searchBtn: CSSProperties = {
    padding:'0px',
    backgroundImage: 'url('+ Tgcc.ResolveUrl('~/images/search_button.png') + ')',
    width: '20px',
    height: '20px',
    backgroundSize: 'cover',
    margin:'4px'
}

class DesignSelectProps extends Tgcc.BaseProps {
    searchFilter: string;
}

type StateType = {
    filter: string,
    category: string,
    license: Tgcc.License,
    design: Tgcc.Design,
    zoomDesign: Tgcc.Design,
    DesignCategories: string[],
    Designs: Tgcc.Design[],
    DesignLicenses: Tgcc.License[]
}


class designSelector extends React.Component <DesignSelectProps,any> {

    componentWillUnmount() {
        document.body.style.overflow = 'auto';
    }

    componentWillMount() {
        document.body.style.overflow = 'hidden';
        this.clearState();
        TgccRequest.getDesignCategories(DIVISION, (categories : string[]) => this.DesignCategoriesLoaded(categories));
        TgccRequest.getDesignLicenses((licenses : Tgcc.License[]) => this.DesignLicensesLoaded(licenses));
    }

    state: StateType = {
        filter: null,
        category: null,
        design: null,
        license: null,
        zoomDesign: null,
        DesignCategories: null,
        Designs: null,
        DesignLicenses: null
    }

    clearState = () => {
        this.setState({
            filter: null,
            category: null,
            design: null,
            zoomDesign: null,
            DesignCategories: null,
            Designs: null});
        this.props.dispatch({ type: Tgcc.StateAction.FilterDesignsByCategory, payload: null})
    }

    DesignCategoriesLoaded(categories : string[]) {
        this.setState({DesignCategories: categories});
    }

    getDesignCategories() {
        var categories = new Array();
        for (var i in this.state.DesignCategories) {
            var cat: string = this.state.DesignCategories[i];
            categories.push(
                <DesignCategory key={i} text={cat} onChange={this.handleFilterByCategory}></DesignCategory>
            )
        };
        return categories;
    }

    DesignLicensesLoaded(licenses : Tgcc.License[]){
        this.setState({DesignLicenses: licenses});
    }

    getDesignLicenses(): JSX.Element[] {
        const licenses: JSX.Element[] = [];
        for (let i = 0; i < this.state.DesignLicenses.length; i++) {
          const lic = this.state.DesignLicenses[i];
          licenses.push(
            <DesignLicense
              key={i}
              license={lic}
              onChange={this.handleFilterByLicense}
            />
          );
        }
        return licenses;
      }
      
    handleFilterByCategory = (category: string) =>{
        TgccRequest.getDesignsByCategoryFiltered(DIVISION, category, this.state.filter, (Designs : Tgcc.Design[]) => this.DesignsLoaded(Designs))
        this.setState({category: category});
        this.props.dispatch({ type: Tgcc.StateAction.FilterDesignsByCategory, payload: category});
    };

    handleFilterByLicense = (license: Tgcc.License) =>{
        TgccRequest.getDesignLicenseDesigns(license.id, (designs : Tgcc.Design[]) => this.DesignsLoaded(designs))
        this.setState({license: license});
        this.props.dispatch({ type: Tgcc.StateAction.FilterDesignsByLicense, payload: license});
    };

    DesignsLoaded(Designs : Tgcc.Design[]) {
        for(var i in Designs)
            Designs[i].displayIndex = Number(i);
        this.setState({Designs: Designs});
    }

    DesignsVisible: boolean = false;
    getDesignItems() {
        this.DesignsVisible = false;
       
        var Designs = new Array();
        var noItemsStyle = { fontFamily: 'CenturyGothic', fontSize:'24px', textAlign: 'center', width: '100%', textTransform: 'uppercase', alignSelf: 'center'};

        if((this.state.category || this.state.filter) && this.state.Designs){
            if(this.state.Designs.length == 0){
                Designs.push( <div key="none" style={noItemsStyle}>No matching items</div>);
            } 

            for(var i in this.state.Designs){
                var design: Tgcc.Design = this.state.Designs[i];
                Designs.push(<DesignCard key={design.id} design={design} onSelect={this.handleDesignSelection} onZoom={this.handleZoom}/>);
            }
            this.DesignsVisible = true;
        } else {
            var chooseSomething = (<div key="none" style={noItemsStyle}>Select a category or search</div>);
            Designs.push(chooseSomething);
        }

        return Designs;
        
    }

    getBackButton(){
        var style : CSSProperties = {
            fontSize: '14px',
            letterSpacing: '3px',
            textAlign: 'center',
            textTransform: 'uppercase',
            marginTop: '10px',
            backgroundColor: Tgcc.Styles.buttonBackground,
            border: '1px solid tranparent',
            width: '40%',
            cursor: 'pointer',
        };
        return ( <div className="hoverBorder" style={style} onClick={this.handleBackToProof}>back</div>)
    }

    handleBackToProof = () => {
        this.props.dispatch({type: Tgcc.StateAction.SetEditState, payload: Tgcc.EditStates.None})
    }

    handleZoom = (design: Tgcc.Design) => {
        this.setState({zoomDesign: design});
    }

    handleDesignSelection = (design : Tgcc.Design) => {
        this.props.dispatch({type: Tgcc.StateAction.UpdateProofDesign, payload: design})
    }


    selectedImageStyle: CSSProperties = {
         display: 'flex',
         width: '200px',
         alignSelf: 'center',
         cursor: 'zoom-in'
    }


    handleDetailBackButton = () => {
        this.setState( { design: null});
    }

    handleTextSearch = (evt: React.KeyboardEvent<HTMLInputElement>) => {
        if(evt.keyCode == 13){ // return keyCode
            this.filterDesignsBySearch(evt.currentTarget.value);
        }

        var style = evt.currentTarget.attributes['style'];
        if(style && style.value){
            if(evt.currentTarget.value)
                evt.currentTarget.attributes['style'].value = style.value.replace('letter-spacing: 6px','letter-spacing: 1px');
            else
                evt.currentTarget.attributes['style'].value = style.value.replace('letter-spacing: 1px','letter-spacing: 6px');
        }
    }

    handleTextSearchBlur = (evt: React.FocusEvent<HTMLInputElement>) => {
        var srch = evt.currentTarget as HTMLInputElement;
        var srchComp = !srch.value ? null : srch.value; // make sure "" is set to null
        if(this.state.filter != srchComp){
            this.filterDesignsBySearch(srch.value);
        }
    }

    filterDesignsBySearch(filter: string){
        filter = filter && filter.length ? filter : null;
        this.setState({filter: filter, Designs: null});
        TgccRequest.getDesignsByCategoryFiltered(DIVISION, this.state.category, filter, (Designs : Tgcc.Design[]) => this.DesignsLoaded(Designs));
    }
    onSubmit(e){
        console.log('clicking');
        e.preventDefault();
    }
    mobileCheck() {
        var isMobile = {
            Android: function() {
                return navigator.userAgent.match(/Android/i);
            },
            BlackBerry: function() {
                return navigator.userAgent.match(/BlackBerry/i);
            },
            iOS: function() {
                return navigator.userAgent.match(/iPhone|iPad/i);
            },
            Opera: function() {
                return navigator.userAgent.match(/Opera Mini|Opera Mobi/i);
            },
            Windows: function() {
                return navigator.userAgent.match(/IEMobile/i);
            },
            any: function() {
                return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
            }
        };
        if (isMobile.any()){
            return (
                <form style={searchFormStyle} onSubmit={this.onSubmit}>
                    <input type="text" className="searchStyle" style={searchStyle} placeholder="Search Designs" onBlur={this.handleTextSearchBlur} onKeyUp={this.handleTextSearch}/>
                    <input style={searchBtn} type="submit" value=""/>
                </form>
            )
        }
        return <input type="text" style={searchStyle} placeholder="Search Designs" onBlur={this.handleTextSearchBlur} onKeyUp={this.handleTextSearch}/>
    }

    render() {
        var categories = this.state.DesignCategories ? this.getDesignCategories() : <Tgcc.LoadingElement />
        var licenses = this.state.DesignLicenses ? this.getDesignLicenses() : <Tgcc.LoadingElement/>
        var searchBlock = this.mobileCheck();
        return (
                <ScreenDoor>
                    <div key="1" className="selectorStyle" style={selectorStyle}>
                        <div key="2" style={categoryContainerStyle}>
                            <div style={closeXStyle}>
                                <CloseX closeAction={this.handleBackToProof} />
                            </div>
                            {searchBlock}
                            <BulletLine text="or" fontSize="12px" bulletSize="3px"/>

                            <div style={smHeadStyle}>choose a school below</div>
                            <div style={categoryListStyle}>{licenses}</div>
                            <div className="catalogStyle" style={catalogStyle}>
                                {this.getDesignItems()}
                            </div>
                            {this.getZoomedDesign()}
                            {this.getBackButton()}
                       </div>
                    </div>
                </ScreenDoor>
                )
    }



    getZoomedDesign = () =>  {
        if(!this.state.zoomDesign)
            return (<a/>);

       let fullSizeStyle: CSSProperties = {
            position: 'relative',
            background: 'white',
            border: Tgcc.Styles.singleBorder,
            boxShadow: Tgcc.Styles.boxShadow,
            padding: '20px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignContent: 'center',
            alignSelf: 'center',
            width: '600px',
            height: '800px',
            maxWidth: '90%',
            maxHeight: '75%',
            '@media (max-width:768px) and (max-height:1024px)': {
                margin:'30px auto'
            },
            '@media (max-width:375px)': {
                maxWidth:'80%',
                maxHeight:'70%'
            }
       };

        let imgStyle: CSSProperties = {
            width: 'auto',
            height: 'auto',
            maxWidth: '80%',
            maxHeight: '75%',
            display: 'block',
            alignSelf: 'center',
            cursor: 'zoom-out'
        };

        let screenDoor: CSSProperties = {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 99,
            backgroundColor: 'rgba(22,22,22,0.5)',
            justifyContent: 'center',
            alignContent: 'center',
            display: 'flex',
            flexDirection: 'column',
            overflowY: 'auto',
            overflowX: 'hidden'
        }        
        let footerStyle: CSSProperties ={
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            width: '100%',
            marginTop: '10px'
        }
        let arrowStyle: CSSProperties = {
            cursor: 'pointer',
            fontSize: '70px',
            height: '40px',
            lineHeight: '30px',
            color: 'darkgray',
            display: 'flex',
            alignSelf: 'center'
        }
        var largeImg = Tgcc.getDesignPath(this.state.zoomDesign.image);
        return ( 
                <ScreenDoor>
                <div style={fullSizeStyle}>
                    <CloseX closeAction={this.hideZoom} />
                    <img src={largeImg} alt={largeImg} style={imgStyle} onError={Tgcc.handleDesignImageError} onClick={this.hideZoom}/> 
                    <div style={footerStyle}>
                        <div style={arrowStyle} onClick={this.handlePrev}>&lsaquo;</div>
                        <div className="grayButton" style={Tgcc.Styles.grayButton} onClick={this.handleZoomAdd}>add to proof</div>
                        <div style={arrowStyle} onClick={this.handleNext}>&rsaquo;</div>
                    </div>  
                </div>
                </ScreenDoor>
        )
    }

    handleImageError = (event: React.SyntheticEvent<HTMLImageElement>) => {
        event.currentTarget.src = Tgcc.Styles.missingDesignImageSrc;
    }

    hideZoom = () => {
        this.setState({zoomDesign: null});
    }

    handleZoomAdd = (evt: React.MouseEvent<HTMLDivElement>) => {
        evt.stopPropagation();
        this.handleDesignSelection(this.state.zoomDesign);
    }

    handlePrev = (evt: React.MouseEvent<HTMLDivElement>) =>{
        evt.stopPropagation();
        var curIndex = this.state.zoomDesign.displayIndex-1;
        curIndex = curIndex < 0 ? this.state.Designs.length - 1 : curIndex;
        this.setState({zoomDesign: this.state.Designs[curIndex]});
    }

    handleNext = (evt: React.MouseEvent<HTMLDivElement>) => {
        evt.stopPropagation();
        var curIndex = this.state.zoomDesign.displayIndex+1;
        curIndex = curIndex >= this.state.Designs.length ? 0 : curIndex;
        this.setState({zoomDesign: this.state.Designs[curIndex]});
    }
}

var _designSelector = Radium(designSelector);

const mapStateToProps = (state : Tgcc.GlobalState, ownState: any) => {
    return {
        searchFilter: state.FilterDesignsBySearch
    }
};

export var DesignSelector = connect(mapStateToProps)(_designSelector);